<section class="get-labels-estimated-costs" data-testid="get-labels-estimated-costs">
  <app-review-estimate-details
    [selectedService]="selectedService()"
    [breakdown]="breakdown()"
    [showCoupon]="false"
    titleKey="createShipment.getLabels.estimatedCostsTitle"
    [paymentDisplay]="paymentDisplay()"
  />
</section>
